import React from "react";
import Topnav from "../common/Topnav";
import Footer from "../common/Footer";
import { Row, Col, Container } from "react-bootstrap";
import { Link } from "react-router-dom";
import bannerImage from "../../Images/student-services/research-banner.webp";
import dora from "../../Images/placement/Dora.webp"

const Dora = () => {
    return (
        <React.Fragment>
            <Topnav />
            <section
                className="section-hero-banner ptb-50"
                style={{
                    backgroundImage: `linear-gradient(rgba(28,36,71,0.8), rgba(77, 77, 77, 0.8)), url(${bannerImage})`,
                }}
            >
                <div className="banner-hero-overlay">
                    <div className="container-xxl">
                        <div className="section-hero-content">
                            <h1>Public Statement Detailing Our Commitment to DORA</h1>
                            <ol className="breadcrumb mt-3 text-center mb-0">
                                <li className="breadcrumb-item">
                                    <Link
                                        to="/"
                                        style={{ color: "#fff", textDecoration: "none" }}
                                    >
                                        Home
                                    </Link>
                                </li>
                                <li
                                    className="breadcrumb-item active text-white"
                                    aria-current="page"
                                >
                                    Public Statement Detailing Our Commitment to DORA
                                </li>
                                <hr className="section-divider" />
                            </ol>
                        </div>
                    </div>
                </div>
            </section>

            <section className="ptb-50">
                <div className="container-xxl">
                    <Row>
                        <Col lg={12}>
                            <div className="evaluation-system ptb-50">
                                <h2 className="modern-title text-center section-title text-blue">
                                    ISBM University: <br /> Public Statement Detailing Our Commitment to DORA
                                </h2>

                                <Container>
                                    <Row className="align-items-center g-4 mt-4">
                                        {/* Left Column for Image */}
                                        <Col lg={4} className="text-center">
                                            <img
                                                src={dora}
                                                alt="DORA Commitment"
                                                className="img-fluid rounded shadow-lg"
                                            />
                                        </Col>

                                        {/* Right Column for Text */}
                                        <Col lg={8}>
                                            <p>
                                                ISBM University is proud to be a signatory of the Declaration on Research
                                                Assessment (DORA).
                                            </p>
                                            <p>
                                                DORA is a global initiative that emphasizes the importance of advancing
                                                research evaluation practices by encouraging the responsible use of metrics
                                                and providing strategic recommendations for more effective and equitable
                                                assessment. At ISBM University, reforming research assessment is a key
                                                priority, enabling us to cultivate and sustain a vibrant research culture.
                                                Through this approach, we ensure our researchers are well-supported in
                                                achieving their full potential, while strengthening both the quality and
                                                impact of our research.
                                            </p>
                                            <p>
                                                In alignment with our commitments to DORA, ISBM University will establish a
                                                Research Assessment Reform Working Group. This group will be responsible for
                                                formulating and implementing a statement on responsible research assessment,
                                                as well as developing a comprehensive action plan to drive the reform of
                                                research evaluation across the University.
                                            </p>
                                            <p>
                                                ISBM University is committed to embedding the principles of DORA across all
                                                its activities. For any enquiries regarding DORA or our research assessment
                                                reform initiatives, please contact <strong>Dr. Trilok</strong>.
                                            </p>
                                        </Col>
                                    </Row>
                                </Container>
                            </div>
                        </Col>
                    </Row>
                </div>
            </section>
            <Footer />
        </React.Fragment>
    );
};

export default Dora;
